import { DEFAULT_BRAND_KIT } from '@/data/brandKit';

export interface FontOption {
  label: string;
  family: string;
}

/** Editor font picker options (brand kit + web fonts). */
export const FONT_FAMILIES: FontOption[] = [
  ...DEFAULT_BRAND_KIT.fonts.map((f) => ({
    label: f.name,
    family: f.family,
  })),
  { label: 'Outfit', family: 'Outfit, Arial, sans-serif' },
  { label: 'Source Sans 3', family: 'Source Sans 3, Arial, sans-serif' },
  { label: 'Inter', family: 'Inter, Arial, sans-serif' },
  { label: 'Poppins', family: 'Poppins, Arial, sans-serif' },
  { label: 'Montserrat', family: 'Montserrat, Arial, sans-serif' },
  { label: 'Roboto', family: 'Roboto, Arial, sans-serif' },
  { label: 'Open Sans', family: 'Open Sans, Arial, sans-serif' },
  { label: 'Lato', family: 'Lato, Arial, sans-serif' },
  { label: 'Nunito', family: 'Nunito, Arial, sans-serif' },
  { label: 'Playfair Display', family: 'Playfair Display, Georgia, serif' },
  { label: 'Merriweather', family: 'Merriweather, Georgia, serif' },
  { label: 'Lora', family: 'Lora, Georgia, serif' },
  { label: 'Space Grotesk', family: 'Space Grotesk, Arial, sans-serif' },
  { label: 'DM Sans', family: 'DM Sans, Arial, sans-serif' },
  { label: 'Georgia', family: 'Georgia, Times New Roman, serif' },
  { label: 'Times New Roman', family: 'Times New Roman, Times, serif' },
  { label: 'Arial', family: 'Arial, Helvetica, sans-serif' },
  { label: 'Verdana', family: 'Verdana, Geneva, sans-serif' },
  { label: 'Trebuchet MS', family: 'Trebuchet MS, Helvetica, sans-serif' },
  { label: 'Courier New', family: 'Courier New, Courier, monospace' },
  { label: 'Comic Sans MS', family: 'Comic Sans MS, Comic Sans, cursive' },
];
